import React, { memo } from 'react'
import Card from 'transfix-ui/components/Card'
import Box from 'transfix-ui/core/Box'
import Grid from 'transfix-ui/core/Grid'
import ShipmentInfoFormSection from './ShipmentInfoFormSection'
import ShipmentStopsFormSection from './ShipmentStopsFormSection'
import ShipmentTermsFormSection from './ShipmentTermsFormSection'

export interface IShipmentFormSectionProps {
  /**
   * @example '124212'
   */
  shipperApplicationId: string
}

const ShipmentFormSection = memo<IShipmentFormSectionProps>(({ shipperApplicationId }) => {
  return (
    <Box mb={4} data-test='shipment-form-section'>
      <Card>
        <Grid container spacing={5}>
          <Grid item xs={12} lg={9}>
            <ShipmentStopsFormSection shipperApplicationId={shipperApplicationId} />
          </Grid>
          <Grid item xs={12} lg={3}>
            <ShipmentInfoFormSection />
            <ShipmentTermsFormSection shipperApplicationId={shipperApplicationId} />
          </Grid>
        </Grid>
      </Card>
    </Box>
  )
})

export default ShipmentFormSection
